export const galleryTourSteps = [
  {
    target: "body",
    content:
      "This is where all your Wheels live, and where guests can explore your public content.",
    placement: "center",
    heading: "Welcome to your Gallery",
    isWelcome: true,
  },
  {
    target: ".create-wheel-button",
    content: `Get started building with our tutorial wizard, or dive straight in and create your Wheel.`,
    placement: "bottom",
    heading: "Create Wheel",
  },
  {
    target: ".wheels-tabs-wrapper",
    content: `See all of your Created, Cloned, Unlocked, and Favorited Wheels here. Keep things tidy by organizing them in Folders.`,
    placement: "bottom",
    heading: "Wheels",
  },
  {
    target: ".link-vault-button",
    content: `Show the world what makes you unique! Have multiple links? Organize them with LinkVault.`,
    placement: "bottom",
    heading: "Profile",
  },
  {
    target: ".business-box",
    content:
      `Your own personal ad space! Showcase offers or businesses - exclusive to ` +
      `<span id="premium-link" style="color: #9B5AF8; cursor: pointer; text-decoration: underline;">Premium</span> ` +
      `(One Business Box) or ` +
      `<span id="prosuite-link" style="color: #9B5AF8; cursor: pointer; text-decoration: underline;">ProSuite</span> ` +
      `(A Business Box for each Wheel)`,
    placement: "right",
    heading: "Business Box",
  },
  {
    target: ".primary-wheel",
    content: `Feature your favorite Wheel - a “Get To Know Me” Wheel is always fun! Switch it up any time.`,
    placement: "bottom",
    heading: "Primary Wheel",
  },
  {
    target: ".feedback-button",
    content:
      `Yep, we’re in Beta! Enjoying the app? For a limited time, use 50ANNUAL when ` +
      `<span id="upgrading-link" style="color: #9B5AF8; cursor: pointer; text-decoration: underline;">upgrading</span> ` +
      `to an annual subscription for 50% off your first year.` +
      `<br/><br/>Got feedback, found a bug, or have a great idea for iYuga? Click the Feedback button and let us know!`,
    placement: "bottom",
    heading: "Feedback",
  },
  {
    target: ".profile-menu",
    heading: "Earnings Portal",
    content:
      `Want passive income? Join the Earnings Program (` +
      `<span id="premium-earnings-link" style="color: #9B5AF8; cursor: pointer; text-decoration: underline;">Premium</span> ` +
      `= 5% / ` +
      `<span id="prosuite-earnings-link" style="color: #9B5AF8; cursor: pointer; text-decoration: underline;">ProSuite</span> ` +
      `= 10%) and get paid EVERY MONTH for each paying subscriber who signs up with your referral code. Check out your Analytics to monitor your Wheels' engagement.`,
    placement: "left",
    offset: 130,
  },
];
